var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FillType } from '../types';
import { stringOfLinearUnit } from './utils';
import { classNames, lodash, polished, css } from 'jimu-core';
export const expandStyleArray = (dataArray) => {
    if (!dataArray || dataArray.length === 0) {
        return [0, 0, 0, 0];
    }
    else if (dataArray.length === 1) {
        return [dataArray[0], dataArray[0], dataArray[0], dataArray[0]];
    }
    else if (dataArray.length === 2) { // top/bottom, left/right
        return [dataArray[0], dataArray[1], dataArray[0], dataArray[1]];
    }
    else if (dataArray.length === 3) {
        return [dataArray[0], dataArray[1], dataArray[2], 0];
    }
    else {
        return [dataArray[0], dataArray[1], dataArray[2], dataArray[3]];
    }
};
export const toCSSBorder = (borderStyle) => {
    if (!borderStyle || !borderStyle.width || !borderStyle.color) {
        return;
    }
    const { width, type, color } = borderStyle;
    return `${stringOfLinearUnit(width)} ${type} ${color}`;
};
export const toCSSMargin = (marginStyle) => {
    if (!marginStyle) {
        return;
    }
    const { number, unit } = marginStyle;
    const margin = expandStyleArray(number);
    return `${margin[0]}${unit} ${margin[1]}${unit} ${margin[2]}${unit} ${margin[3]}${unit}`;
};
export const toCSSPadding = (paddingStyle) => {
    return toCSSMargin(paddingStyle);
};
export const toCSSBoxshadow = (boxShadow) => {
    if (!boxShadow || !boxShadow.color || boxShadow.presetStyle) {
        return;
    }
    const { offsetX, offsetY, blur, spread, color } = boxShadow;
    return `${stringOfLinearUnit(offsetX)} ${stringOfLinearUnit(offsetY)} ${stringOfLinearUnit(blur)} ${stringOfLinearUnit(spread)} ${color}`;
};
export const toCSSBorderRadius = (borderRadius) => {
    if (!borderRadius) {
        return;
    }
    const { number, unit } = borderRadius;
    const rArray = expandStyleArray(number);
    return `${rArray[0]}${unit} ${rArray[1]}${unit} ${rArray[2]}${unit} ${rArray[3]}${unit}`;
};
export const toCSSWidth = (widthStyle) => {
    if (!(widthStyle === null || widthStyle === void 0 ? void 0 : widthStyle.value)) {
        return;
    }
    const { value } = widthStyle;
    return stringOfLinearUnit(value);
};
export const toCSSHeight = (heightStyle) => {
    if (!(heightStyle === null || heightStyle === void 0 ? void 0 : heightStyle.value)) {
        return;
    }
    const { value } = heightStyle;
    return stringOfLinearUnit(value);
};
export const toCSSTextAlign = (text) => {
    if (!text) {
        return;
    }
    return `${text.align}`;
};
export const toCSSTextUnderLine = (text) => {
    if (!text) {
        return 'none';
    }
    if (text.underline && text.strike) {
        return 'underline line-through';
    }
    else if (text.underline) {
        return 'underline';
    }
    else if (text.strike) {
        return 'line-through';
    }
    return 'none';
};
export const toCSSTextFontStyle = (text) => {
    if (!text) {
        return;
    }
    const fontStyle = text.italic ? 'italic' : 'normal';
    return fontStyle;
};
export const toCSSTextFontWeight = (text) => {
    if (!text) {
        return;
    }
    const fontWeight = text.bold ? 'bold' : 'normal';
    return fontWeight;
};
export const toCSSTextFontSize = (text) => {
    if (!text) {
        return;
    }
    return text.size;
};
export const toCSSTextFontFamily = (text) => {
    if (!text) {
        return;
    }
    return text.font;
};
export const toCSSTextColor = (text) => {
    if (!text) {
        return;
    }
    return `${text.color}`;
};
export const toCSSTextStyle = (text) => {
    if (!text)
        return;
    const style = {
        fontStyle: toCSSTextFontStyle(text),
        fontWeight: toCSSTextFontWeight(text),
        fontSize: toCSSTextFontSize(text),
        fontFamily: toCSSTextFontFamily(text),
        textDecoration: toCSSTextUnderLine(text),
        textAlign: toCSSTextAlign(text),
        color: toCSSTextColor(text)
    };
    if (text === null || text === void 0 ? void 0 : text.background) {
        style.background = text.background;
    }
    if (text === null || text === void 0 ? void 0 : text.letterspace) {
        style.letterSpacing = text.letterspace;
    }
    if (text === null || text === void 0 ? void 0 : text.linespace) {
        style.lineHeight = text.linespace;
    }
    return style;
};
export const resolveTextStyle = (text = {}) => {
    return css `
    font-style: ${toCSSTextFontStyle(text)};
    font-weight: ${toCSSTextFontWeight(text)};
    font-size: ${toCSSTextFontSize(text)};
    font-family: ${toCSSTextFontFamily(text)};
    text-decoration: ${toCSSTextUnderLine(text)};
    text-align: ${toCSSTextAlign(text)};
    color: ${toCSSTextColor(text)};
    background: ${text.background};
    letter-spacing: ${text.letterspace};
    line-height: ${text.linespace};
  `;
};
export function toCSSTransform(transform) {
    let value = '';
    if ((transform === null || transform === void 0 ? void 0 : transform.rotate) > 0 || (transform === null || transform === void 0 ? void 0 : transform.rotate) < 0) {
        value = `${value} rotate(${transform.rotate}deg)`;
    }
    return value;
}
export const toCSSStyle = (styleSettings) => {
    if (!styleSettings) {
        return {};
    }
    const { background = {}, backgroundColor, border, borderLeft, borderRight, borderTop, borderBottom, margin, padding, boxShadow, borderRadius, width, text, height, transform } = styleSettings, others = __rest(styleSettings, ["background", "backgroundColor", "border", "borderLeft", "borderRight", "borderTop", "borderBottom", "margin", "padding", "boxShadow", "borderRadius", "width", "text", "height", "transform"]);
    const backgroundStyle = toBackgroundStyle(background);
    const textStyle = toCSSTextStyle(text);
    const styles = lodash.assign({}, Object.assign({ backgroundColor: backgroundColor, margin: toCSSMargin(margin), padding: toCSSPadding(padding), boxShadow: toCSSBoxshadow(boxShadow), borderRadius: toCSSBorderRadius(borderRadius), width: toCSSWidth(width), height: toCSSHeight(height), transform: toCSSTransform(transform), border: toCSSBorder(border) }, others), backgroundStyle, textStyle);
    Object.keys({ borderLeft, borderRight, borderTop, borderBottom }).forEach((key) => {
        if (styleSettings[key]) {
            styles[key] = toCSSBorder(styleSettings[key]);
        }
    });
    // remove null style
    const keys = Object.keys(styles);
    keys.forEach((key) => {
        if (styles[key] == null) {
            delete styles[key];
        }
    });
    return styles;
};
export const toBackgroundStyle = ({ color, image, fillType }) => {
    if (!color && !image) {
        return;
    }
    return {
        backgroundImage: image && image.url ? `url(${image.url})` : undefined,
        backgroundColor: color,
        backgroundPosition: 'center',
        backgroundRepeat: fillType === 'tile' ? 'repeat' : 'no-repeat',
        backgroundSize: classNames({ contain: fillType === 'fit' }, { cover: fillType === 'fill' }, { auto: fillType === 'tile' || fillType === 'center' }, { '100% 100%': fillType === 'stretch' })
    };
};
export const toBackgroundEmotionStyle = ({ color, image, fillType }) => {
    if (!color && !image) {
        return;
    }
    let size;
    switch (fillType) {
        case FillType.FIT:
            size = 'contain';
            break;
        case FillType.FILL:
            size = 'cover';
            break;
        case FillType.TILE:
        case FillType.CENTER:
            size = 'auto';
            break;
        case FillType.STRETCH:
            size = '100% 100%';
            break;
    }
    return css `
    background-image: ${image && image.url ? `url(${image.url})` : null};
    background-color: ${color};
    background-position: center;
    background-repeat: ${fillType === 'tile' ? 'repeat' : 'no-repeat'};
    background-size: ${size};
  `;
};
export const remToPixel = (pxValue, base) => {
    const [pxNumber, pxUnit] = polished.getValueAndUnit(pxValue);
    if (pxUnit !== 'rem')
        return pxValue;
    let rootFontSizeAsPx = 16;
    const rootFontSize = base || '100%';
    const [rootFontsizeNumber, rootFontsizeUnit] = polished.getValueAndUnit(rootFontSize);
    if (rootFontsizeUnit === '%') {
        rootFontSizeAsPx = rootFontsizeNumber * 0.01 * 16;
    }
    else if (rootFontsizeUnit === 'px') {
        rootFontSizeAsPx = rootFontsizeNumber;
    }
    return pxNumber * rootFontSizeAsPx + 'px';
};
/**
 * The following methods are for navigation only
 */
export const getButtonIconStyle = (variant, useForNavLink) => {
    var _a, _b, _c, _d, _e;
    const className = useForNavLink ? '.jimu-nav-link-wrapper' : '.icon-btn-sizer';
    return css `
   font-size: ${(variant === null || variant === void 0 ? void 0 : variant.size) ? `${polished.rem(variant.size)}!important` : ''};
   ${className} > .jimu-icon {
    width: ${((_a = variant === null || variant === void 0 ? void 0 : variant.icon) === null || _a === void 0 ? void 0 : _a.size) ? polished.rem((_b = variant === null || variant === void 0 ? void 0 : variant.icon) === null || _b === void 0 ? void 0 : _b.size) : ''};
    height: ${((_c = variant === null || variant === void 0 ? void 0 : variant.icon) === null || _c === void 0 ? void 0 : _c.size) ? polished.rem((_d = variant === null || variant === void 0 ? void 0 : variant.icon) === null || _d === void 0 ? void 0 : _d.size) : ''};
    color: ${(_e = variant === null || variant === void 0 ? void 0 : variant.icon) === null || _e === void 0 ? void 0 : _e.color};
   }
 `;
};
export const getButtonStyleByState = (variants, useForNavLink) => {
    const regular = variants === null || variants === void 0 ? void 0 : variants.default;
    const active = variants === null || variants === void 0 ? void 0 : variants.active;
    const hover = variants === null || variants === void 0 ? void 0 : variants.hover;
    const disabled = variants === null || variants === void 0 ? void 0 : variants.disabled;
    return css `
    .jimu-btn {
      &:not(:disabled):not(.disabled) {
        ${getButtonIconStyle(regular, useForNavLink)};
      }
      ${hover && css `
      &:not(:disabled):not(.disabled):hover {
          ${getButtonIconStyle(hover, useForNavLink)};
        }
      ${active && css `
        &:not(:disabled):not(.disabled).active,
        &[aria-expanded="true"] {
          ${getButtonIconStyle(active, useForNavLink)}
        }
        &:not(:disabled):not(.disabled) {
          cursor: pointer;
        }
      `}
      ${disabled && css `
        &.disabled,
        &:disabled {
          ${getButtonIconStyle(disabled, useForNavLink)}
        }
      `}
    `}
    }
  `;
};
